//
//
//
//
//
//
//
//
//
//
//

import NavBarCompany from '@/components/Menu/NavBar/NavBarCompany.vue'
import LoadingSpinner from '@/components/Shared/LoadingSpinner'
import Menu from '@/components/Menu/menu.vue'
export default {
  name: 'DashboardCompany',
  middleware: [],
  components: {
    NavBarCompany,
    Menu,
    LoadingSpinner,
  },
  data() {
    return {
      flag: false,
      showFooter: false,
    }
  },
  mounted() {
    document.documentElement.classList.remove('has-aside-left')
    document.documentElement.classList.remove('has-aside-mobile-transition')
    document.documentElement.classList.remove('has-navbar-fixed-top')
    document.documentElement.classList.remove('has-aside-expanded')
  },
  methods: {},
  head() {
    const i18nSeo = this.$nuxtI18nSeo()
    return {
      htmlAttrs: {
        lang: 'es',
        ...i18nSeo.htmlAttrs,
      },
      meta: i18nSeo.meta,
      link: i18nSeo.link,
    }
  },
}
